import React from 'react'
import PropTypes from 'prop-types'

import { CommonSlider } from 'components'

import { SliderSectionBg } from 'assets/images'
import { ArrowLeft2 } from 'iconsax-react'

import styles from './styles.module.css'
import useColors from 'utils/Colors'
import { Link } from 'react-router-dom'

const SliderSection = ({
  background,
  containerStyles,
  items,
  title,
  textColor,
  moreUrl,
}) => {
  const Colors = useColors()

  return (
    <div
      className={styles.container}
      style={{ background, ...containerStyles }}
    >
      <div className={styles.header}>
        <h4 style={{ color: textColor }}>{title}</h4>
        <Link to={moreUrl} style={{ color: textColor }}>
          همه <ArrowLeft2 size={12} color={textColor} />
        </Link>
      </div>
      <CommonSlider
        className="slider-section"
        items={items.map((item) => (
          <div style={{ width: 143 }}>{item}</div>
        ))}
        sliderOptions={{
          autoWidth: true,
          autoPlay: true,
          gap: '16px',
          padding: { right: '16px' },
        }}
      />
    </div>
  )
}

SliderSection.defaultProps = {
  background: 'white',
  containerStyles: {},
  title: 'حراج این هفته',
  titleClassName: '',
  moreClassName: '',
}

SliderSection.propTypes = {
  containerStyles: PropTypes.object,
  items: PropTypes.array,
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  moreClassName: PropTypes.string,
}
export default SliderSection
